import styled, { css } from 'styled-components';
import { Box, AvatarGroup, AvatarSize, AvatarGroupSpacing } from '@bechtel/gds';

interface StencilRodContainerStyledProps {
  isRequestExpired: boolean;
  isSelected: boolean;
}
export const StencilRodContainerStyled = styled.div<StencilRodContainerStyledProps>`
  ${({ theme, isRequestExpired, isSelected }) => css`
    padding-left: ${theme.spacings[400]};
    padding-top: ${theme.spacings[450]};
    padding-bottom: ${theme.spacings[450]};
    padding-right: ${theme.spacings[500]};
    position: relative;
    display: grid;
    grid-template-columns: 4% 45% 19% 32%;
    border-bottom: 1px solid ${theme.colors.grey[300]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
    ${isRequestExpired &&
    css`
      background-color: ${theme.colors.red[100]};
    `}
    ${isSelected &&
    css`
      background-color: ${theme.colors.bechtel.blue[100]};
    `}
    &:hover {
      background-color: ${theme.colors.bechtel.blue[100]};
    }
  `}
`;

export const AvatarGroupStyled = styled(AvatarGroup).attrs({
  size: AvatarSize.MEDIUM,
  spacing: AvatarGroupSpacing.SMALL,
  maxCount: 2,
})`
  border-width: 1px !important;
  ${({ theme }) => css`
    border-color: ${theme.colors.white};
  `}
`;
export const ExpiredStyled = styled(Box)`
  ${({ theme }) => css`
    top: ${theme.spacings[200]};
    right: ${theme.spacings[200]};
    position: absolute;
  `}
`;
